module.exports = __webpack_public_path__ + "img/pdf_icon.550ec221.png";